var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevicesCompliant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.1617 1.38965H4.81999C2.79494 1.38965 1.15332 3.03128 1.15332 5.05632V23.9764C1.15332 26.0014 2.79494 27.643 4.81999 27.643H35.1617C37.1867 27.643 38.8283 26.0014 38.8283 23.9764V5.05632C38.8283 3.03128 37.1867 1.38965 35.1617 1.38965Z",
    stroke: "#0C1CAB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7383 27.625V34.61",
    stroke: "#0C1CAB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2617 27.625V34.61",
    stroke: "#0C1CAB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75342 34.6099H32.2468",
    stroke: "#0C1CAB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.867 7.7334H7.80029C7.24801 7.7334 6.80029 8.18111 6.80029 8.7334V14.8001C6.80029 15.3524 7.24801 15.8001 7.80029 15.8001H13.867C14.4192 15.8001 14.867 15.3524 14.867 14.8001V8.7334C14.867 8.18111 14.4192 7.7334 13.867 7.7334Z",
    fill: "#AFD0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2002 7.7334H17.3335C16.7812 7.7334 16.3335 8.18111 16.3335 8.7334V14.8001C16.3335 15.3524 16.7812 15.8001 17.3335 15.8001H32.2002C32.7525 15.8001 33.2002 15.3524 33.2002 14.8001V8.7334C33.2002 8.18111 32.7525 7.7334 32.2002 7.7334Z",
    fill: "#AFD0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2003 16.5332H7.80029C7.24801 16.5332 6.80029 16.9809 6.80029 17.5332V19.9332C6.80029 20.4855 7.24801 20.9332 7.80029 20.9332H32.2003C32.7526 20.9332 33.2003 20.4855 33.2003 19.9332V17.5332C33.2003 16.9809 32.7526 16.5332 32.2003 16.5332Z",
    fill: "#AFD0FF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_64_13)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 3,
    width: 16,
    height: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_64_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6666 10.3867V11.0001C34.6658 12.4377 34.2003 13.8365 33.3395 14.988C32.4787 16.1394 31.2688 16.9817 29.8902 17.3893C28.5115 17.797 27.0381 17.748 25.6896 17.2498C24.341 16.7516 23.1897 15.8308 22.4072 14.6248C21.6248 13.4188 21.2531 11.9921 21.3477 10.5576C21.4423 9.12312 21.9981 7.75762 22.9321 6.66479C23.8662 5.57195 25.1284 4.81033 26.5307 4.4935C27.933 4.17668 29.4001 4.32163 30.7133 4.90674",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6666 5.66674L27.9999 12.3401L25.9999 10.3401",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6666 10.3867V11.0001C34.6658 12.4377 34.2003 13.8365 33.3395 14.988C32.4787 16.1394 31.2688 16.9817 29.8902 17.3893C28.5115 17.797 27.0381 17.748 25.6896 17.2498C24.341 16.7516 23.1897 15.8308 22.4072 14.6248C21.6248 13.4188 21.2531 11.9921 21.3477 10.5576C21.4423 9.12312 21.9981 7.75762 22.9321 6.66479C23.8662 5.57195 25.1284 4.81033 26.5307 4.4935C27.933 4.17668 29.4001 4.32163 30.7133 4.90674M34.6666 5.66674L27.9999 12.3401L25.9999 10.3401",
    stroke: "#14AE5C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 3.5,
    width: 15,
    height: 15,
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_64_13",
    x: 16.8333,
    y: 3.82959,
    width: 22.3333,
    height: 22.3335,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.496594 0 0 0 0 0.814102 0 0 0 0 0.425316 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_64_13"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_64_13",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 36,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_64_13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 3,
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicesCompliant);
export default __webpack_public_path__ + "static/media/devices-compliant.fa949a406ea5c275df4cce9ec014f266.svg";
export { ForwardRef as ReactComponent };